import whiteLogo from 'assets/logos/logomark-white.svg'

function MobileLayover() {
  return (
    <div className="mobile-layover">
      <img src={whiteLogo} alt="logo" />
      <h2>The Superposition app is only accessible from a desktop browser.</h2>
      <a href="https://www.superposition.finance/" target="_blank" rel="noopener noreferrer">
        <button className="sp-btn white">Go to Superposition website</button>
      </a>
    </div>
  )
}

export default MobileLayover
